'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRowing = function MdRowing(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 35l-5 5-5-5v-2.5l-11.8-11.8c-0.5 0.1-1.1 0.1-1.6 0.1v-3.6c2.8 0.1 6.1-1.4 7.9-3.4l2.3-2.6c0.6-0.5 1.6-1.2 2.7-1.2h0.1c2 0 3.8 1.7 3.8 3.7v9.7c0 1.4-0.7 2.6-1.6 3.6l-5.9-6v-3.8c-1.1 0.8-2.5 1.7-3.9 2.3l10.5 10.5h2.5z m-10-33.4c1.8 0 3.4 1.6 3.4 3.4s-1.6 3.4-3.4 3.4-3.4-1.6-3.4-3.4 1.6-3.4 3.4-3.4z m-10.9 22.5l4.3 4.3h-3.4l-5.9 5.7-2.5-2.5z' })
        )
    );
};

exports.default = MdRowing;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/rowing.js
// module id = 2731
// module chunks = 0